// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.isf8Gc5_GjFk8geGtNve {
  display: inline-block;
  position: relative;
}
.isf8Gc5_GjFk8geGtNve > input {
  width: 100%;
  max-width: 100%;
  padding-right: 3em;
}
.isf8Gc5_GjFk8geGtNve > svg {
  position: absolute;
  right: 0.4em;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.isf8Gc5_GjFk8geGtNve > svg path {
  fill: var(--dry-border-color);
}
.isf8Gc5_GjFk8geGtNve > input:autofill + svg {
  display: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `isf8Gc5_GjFk8geGtNve`
};
export default ___CSS_LOADER_EXPORT___;
